import { LoginButton } from './LoginButton'
import { FormInput } from 'components/molecules/FormInput'
import { Form } from 'components/atoms/Form'
import { Text } from 'components/atoms/Text'
import { useFormContext } from 'react-hook-form'

interface Props {
  onSubmit: () => void
}

export const EnterEmailForm = ({ onSubmit }: Props) => {
  const {
    handleSubmit,
    formState: { isValid, isDirty },
  } = useFormContext()

  const handleClick = handleSubmit(async () => {
    onSubmit()
  })
  return (
    <>
      <div>
        <Text>Please enter your email to verify or create an account.</Text>
        <Text>
          The authentication link that you will receive is valid for <strong>24hrs</strong>
          <br />
          and is usable once.
        </Text>
      </div>
      <Form id="magic-link-form">
        <FormInput id="email" label="Email" isRequired placeholder="you@website.com" />
        <LoginButton disabled={isDirty && !isValid} view="primary" onClick={handleClick}>
          Confirm
        </LoginButton>
      </Form>
    </>
  )
}
